import React from 'react'
import { SvgIcon } from '../svg-icon'
import styles from './position-notification-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a position notification icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PositionNotificationIcon width={12} />
 */
const PositionNotificationIcon = props => (
    <SvgIcon className={styles['position-notification-icon']} viewBox="0 0 48 48" {...props}>
        <path
            d={`M37.609,7.6a19.333,19.333,0,0,0-27.22,0,19.045,19.045,0,0,
            0,.005,27.058C13.878,38.123,24,46,24,46s10.126-7.88,13.611-11.342a19.047,
            19.047,0,0,0,0-27.057`}
        />
        <path
            d={`M36.7,8.92a18.045,18.045,0,0,0-25.406,0A17.775,17.775,0,0,0,11.3,
            34.177C14.553,37.408,24,44.759,24,44.759s9.451-7.354,12.7-10.586a17.777,
            17.777,0,0,0,0-25.253`}
        />
        <path
            d={`M33.326,24.569,26.87,13.552A3.323,3.323,0,0,0,24,11.663a3.325,3.325,
            0,0,0-2.871,1.89L14.674,24.541a3.407,3.407,0,0,0-.11,3.437,3.612,3.612,0,0,
            0,3.168,1.593H30.268a3.592,3.592,0,0,0,3.168-1.565A3.407,3.407,0,0,0,33.326,
            24.569ZM24,27.916a1.724,1.724,0,1,1,1.725-1.723A1.723,1.723,0,0,1,24,
            27.916Zm1.3-5.7a1.3,1.3,0,0,1-2.586,0c-.054-.7-.431-5.57-.431-5.57a1.734,
            1.734,0,0,1,3.447,0S25.343,21.5,25.295,22.216Z`}
        />
    </SvgIcon>
)

PositionNotificationIcon.defaultProps = defaultProps

export { PositionNotificationIcon }
